import { c as _c } from "react/compiler-runtime";
import { RefObject } from 'react';
import ActionWorldCard from '@/components/ActionWorldCard';
import ViverseWorldCard from '@/components/ViverseWorldCard';
import { CARD_CLASS_SWIMLANE } from '@/constants/card';
import { useConfigsContext } from '@/context/ConfigsContext';
import { useDraggingScrollMotion } from '@/hooks/useDraggingScrollMotion';
import { extractRoomIdFromUrl } from '@/lib/cms';
import { cn } from '@/lib/utils';
import { getCardType, isNewRoom, isUpdatedRoom } from '@/lib/viverse-world-card';
import type { WorldCardInfo, WorldCardLane } from '@/types/viverse-world-card';
type WorldCardRoom = WorldCardInfo | null | undefined;
type AllWorldsCardsProps = {
  cardVariant?: 'action' | 'viverse';
  world?: WorldCardLane;
  rooms?: WorldCardRoom[];
  scrollRef: RefObject<HTMLDivElement | null>;
  enableDraggingScroll: boolean;
  scrollClassName?: string;
  contentInsetClassName?: string;
  dataRoomIdPrefix?: string;
  lastCardClassName?: string;
  cardClassName?: string;
  ranking?: boolean;
  isNew?: boolean;
  isMission?: boolean;
  suppressFreshnessBadges?: boolean;
  isExclusive?: boolean;
  rawCardType?: boolean;
  hidePremiumBadge?: boolean;
  hideLiked?: boolean;
  forceShowPremiumBadge?: boolean;
  onScroll?: () => void;
};
function AllWorldsCards(t0) {
  const $ = _c(9);
  const {
    cardVariant: t1,
    world,
    rooms,
    scrollRef,
    enableDraggingScroll,
    scrollClassName: t2,
    contentInsetClassName,
    dataRoomIdPrefix: t3,
    lastCardClassName: t4,
    cardClassName,
    ranking,
    isNew,
    isMission,
    suppressFreshnessBadges: t5,
    isExclusive,
    rawCardType: t6,
    hidePremiumBadge,
    hideLiked,
    forceShowPremiumBadge,
    onScroll
  } = t0;
  const cardVariant = t1 === undefined ? "action" : t1;
  const scrollClassName = t2 === undefined ? "no-scrollbar relative flex w-full flex-1 gap-4 overflow-x-auto overflow-y-hidden pl-4 max-md:min-h-60 md:min-h-56 md:pl-4 lg:pl-6" : t2;
  const dataRoomIdPrefix = t3 === undefined ? "awc" : t3;
  const lastCardClassName = t4 === undefined ? "mr-4 lg:mr-6" : t4;
  const suppressFreshnessBadges = t5 === undefined ? false : t5;
  const rawCardType = t6 === undefined ? false : t6;
  const {
    store
  } = useConfigsContext();
  const sourceRooms = rooms ?? world?.rooms ?? [];
  const viverseRooms = sourceRooms.filter(_temp);
  useDraggingScrollMotion(scrollRef);
  let t7;
  if ($[0] !== contentInsetClassName || $[1] !== enableDraggingScroll || $[2] !== scrollClassName) {
    t7 = cn(scrollClassName, {
      "cursor-grab": enableDraggingScroll
    }, contentInsetClassName);
    $[0] = contentInsetClassName;
    $[1] = enableDraggingScroll;
    $[2] = scrollClassName;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const t8 = cardVariant === "action" ? sourceRooms.map((room_0, index) => {
    if (!room_0) {
      return null;
    }
    const isLast = index === sourceRooms.length - 1;
    return <ActionWorldCard key={`${room_0.id}-${index}`} className={cn(CARD_CLASS_SWIMLANE, {
      "1.5xl:mr-10 3xl:mr-20 mr-4 md:mr-6": isLast
    }, cardClassName)} info={room_0} anchorId={room_0.id ? `awc:${room_0.id}` : undefined} hideLiked={hideLiked || !store?.credentials?.htcToken} ranking={ranking} rankingIndex={index + 1} isNew={isNew} isMission={isMission} isExclusive={isExclusive ?? room_0.is_exclusive ?? false} hidePremiumBadge={hidePremiumBadge} forceShowPremiumBadge={forceShowPremiumBadge} />;
  }) : viverseRooms.map((room_1, index_0) => {
    const isLast_0 = index_0 === viverseRooms.length - 1;
    return <ViverseWorldCard key={`${room_1.id}-${index_0}`} info={room_1} href={extractRoomIdFromUrl(room_1.external_link || room_1.hubs_url || "/")} data-room-id={room_1.id ? `${dataRoomIdPrefix}:${room_1.id}` : undefined} className={cn(CARD_CLASS_SWIMLANE, cardClassName, isLast_0 && lastCardClassName)} cardType={rawCardType ? room_1.content_type?.code ?? "experiences" : getCardType(room_1.content_type)} ranking={ranking} rankingIndex={index_0 + 1} hideLiked={hideLiked} hidePremiumBadge={hidePremiumBadge} forceShowPremiumBadge={forceShowPremiumBadge} isNew={suppressFreshnessBadges ? false : isNewRoom(room_1.first_public_date)} isUpdated={suppressFreshnessBadges ? false : isUpdatedRoom(room_1.last_updated_at, room_1.first_public_date)} isExclusive={isExclusive ?? room_1.is_exclusive ?? false} />;
  });
  let t9;
  if ($[4] !== onScroll || $[5] !== scrollRef || $[6] !== t7 || $[7] !== t8) {
    t9 = <div ref={scrollRef} className={t7} onScroll={onScroll}>{t8}</div>;
    $[4] = onScroll;
    $[5] = scrollRef;
    $[6] = t7;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  return t9;
}
function _temp(room) {
  return Boolean(room);
}
export default AllWorldsCards;